export default function Notification({ message, status }) {
    const styles = {
        success: "bg-green-600/90 border-green-400",
        error: "bg-red-600/90 border-red-400",
        warning: "bg-yellow-500/90 border-yellow-300 text-black",
        info: "bg-blue-600/90 border-blue-400",
    };

    const icons = {
        success: "✓",
        error: "✕",
        warning: "⚠",
        info: "ℹ",
    };

    return (
        <div
            className={`
                fixed
                top-32
                left-1/2
                -translate-x-1/2
                z-50
                flex
                items-center
                gap-3
                px-6
                py-4
                rounded-xl
                border
                text-white
                shadow-xl
                backdrop-blur-md
                animate-fade-in
                ${styles[status] || styles.info}
            `}
        >
            <span className="text-lg font-bold">
                {icons[status] || icons.info}
            </span>

            <span className="font-medium">
                {message}
            </span>
        </div>
    );
}